import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogContent} from "@mui/material";

import Form from "views/optionValues/components/Content/components/Form";

import {ListContext} from "components/List/context/ListContext";

CreateOptionValueDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    option: PropTypes.object,
    lastPosition: PropTypes.number,
    initialName: PropTypes.string,
    onCreated: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

/**
 * Standalone wrapper around the option value creation form of the
 * /option_values page, so the quick-create flow reuses the exact same form
 * (translations per locale, hexadecimal color for Color options).
 *
 * The form reads `loading` and `closeCreateDialog` from ListContext: a stub
 * provider maps them onto this dialog's props.
 */
export default function CreateOptionValueDialog({isOpen, option, lastPosition, initialName, onCreated, onClose}) {
    if (!option) {
        return null;
    }

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth={'sm'}
            scroll={'body'}
        >
            <DialogContent>
                <ListContext.Provider value={{loading: false, closeCreateDialog: onClose}}>
                    <Form
                        option={option}
                        lastPosition={lastPosition ?? 0}
                        initialName={initialName ?? ''}
                        refreshList={(created) => onCreated(created)}
                    />
                </ListContext.Provider>
            </DialogContent>
        </Dialog>
    );
}
